module.exports = __webpack_public_path__ + "static/media/team.bd77c28c.png";